import { LatLngBounds } from 'leaflet';

export function isFiniteLatLng(lat: number, lng: number): boolean {
  return (
    Number.isFinite(lat) &&
    Number.isFinite(lng) &&
    lat >= -90 &&
    lat <= 90 &&
    lng >= -180 &&
    lng <= 180
  );
}

/** Builds Leaflet bounds from check-in markers (expects `[lat, lng][]`, not a single pair). */
export function buildMarkersLatLngBounds(
  markers: { lat: number; lng: number }[],
): LatLngBounds | null {
  const latLngs = markers
    .filter(m => isFiniteLatLng(m.lat, m.lng))
    .map(m => [m.lat, m.lng] as [number, number]);

  if (latLngs.length === 0) {
    return null;
  }

  const bounds = new LatLngBounds(latLngs);
  return bounds.isValid() ? bounds : null;
}
